<div class="dialog-wrapper">
  <h3 mat-dialog-title>{{ data.title }}</h3>
  <div mat-dialog-content>
    <div class="password-display">
      <span class="password-value">{{ data.password }}</span>
      <button mat-icon-button (click)="copyPassword()" class="copy-btn" [matTooltip]="'shared.general.labels.copy' | translate">
        <mat-icon>content_copy</mat-icon>
      </button>
    </div>
    <div class="auto-copy-hint">
      {{ 'app.user.actions.reset_password.success.auto_copied' | translate }}
    </div>
  </div>
  <div mat-dialog-actions>
    <div class="dialog-actions">
      <button mat-flat-button color="primary" (click)="onClose()">
        <span>{{ 'shared.general.buttons.close' | translate }}</span>
      </button>
    </div>
  </div>
</div>
